module.exports = __webpack_public_path__ + "img/D202212_2.2520cfb5.jpg";